/**
 * Transaction Extend Dialog (Stub)
 * 基底平台不使用 Transaction Token 機制，此為相容性 stub
 */

import React from 'react';

const TransactionExtendDialog: React.FC<any> = () => {
  return null;
};

export default TransactionExtendDialog;
